/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * All possible Service Unavailable problems.
 */
export type ServiceUnavailableProblems = Truvity.ServiceUnavailableProblems.ServiceUnavailable;

export namespace ServiceUnavailableProblems {
    export interface ServiceUnavailable extends Truvity.ProblemServiceUnavailable {
        type: '/service-unavailable';
    }
}
